export enum DeliveryMethod {
    Email = 'email',
    InApp = 'inApp',
}

export enum UserTag {
    UserAdded = 'UserAdded',
    UserRemoved = 'UserRemoved',
    UserRoleChanged = 'UserRoleChanged',
    IPWhitelistRestriction = 'IPWhitelistRestriction',
}

export enum PlatformTag {
    FileScanThreshold = 'FileScanThreshold',
    ScanResultCode = 'ScanResultCode',
}

export enum LimitInterval {
    Monthly = 'monthly',
    Daily = 'daily',
}

export enum LimitAPI {
    Prevention = 'Prevention',
    Reputation = 'Reputation',
    Sandbox = 'Sandbox',
    Download = 'Download',
}

export enum LimitPercentage {
    Fifty = '50%',
    Sixty = '60%',
    Seventy = '70%',
    Eighty = '80%',
    Ninety = '90%',
    Hundred = '100%',
}

export type LimitTag = `${Capitalize<LimitInterval>}Limit-${LimitAPI}API-${LimitPercentage}`;

export interface SubscribedTag {
    tag?: UserTag | PlatformTag | LimitTag;
    description?: string;
    delivery?: DeliveryMethod[];
}
